// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  schema: 'https://',
  googleId: '931311149290-hqiikq3mkn8s6rjrimvac2k0l0n1r4is.apps.googleusercontent.com',
  facebookID: '5464572096948717',
  apiKey:'1_3bcbxd9e24g0gk4swg0kwgcwg4o8k8g4g888kwc44gcc0gwwk4',
  apiSec:'4ok2x70rlfokc8g0wws8c8kwcokw80k44sg48goc0ok4w0so0k',
  apiKeyG:'4_3bcbxd9e24g0gk4swg0kwgcwg4o8k8g4g888kwc44gcc0gwwk4',
  apiSecG:'4ok2x70rlfokc8g0wws8c8kwcokw80k44sg48goc0ok4w0so0k',
  apiKeyF: '4_3bcbxd9e24g0gk4swg0kwgcwg4o8k8g4g888kwc44gcc0gwwk4',
  apiSecF: '4ok2x70rlfokc8g0wws8c8kwcokw80k44sg48goc0ok4w0so0k',
  apiUrl:'com.sitefreeman.com',
  sourceURL:'com.sitefreeman.com',
  locales: ['en', 'pl'],
  defaultLocale: 'pl',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
